import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <p>
      <p><strong parentName="p">{`What is Extract?`}</strong></p>
      <p><a parentName="p" {...{
          "href": "./howtos/extract-api.md"
        }}>{`The PDF Extract API (included with the PDF Services API)`}</a>{` is a cloud-based web service that uses Adobe’s Sensei AI technology to automatically extract content and structural information from PDF documents – native or scanned – and to output it in a structured JSON format. The service extracts text, complex tables, and figures as follows:`}</p>
      <ul>
        <li parentName="ul">{`Text is extracted in contextual blocks – paragraphs, headings, lists, footnotes, etc. – and includes font, styling, and other text formatting information.`}</li>
        <li parentName="ul">{`Tables are extracted and parsed with the contents and table formatting information delivered for each cell. The service automatically identifies table cells that span multiple rows or columns. Table data is delivered within the resulting JSON and can also optionally be output in CSV and XLSX files. Tables are also output as PNG images allowing the table data to be visually validated.`}</li>
        <li parentName="ul">{`Objects that are identified as figures or images are extracted as PNG files.`}</li>
      </ul>
      <p>{`The JSON output also captures document structure information, such as the natural reading order of the various extracted elements and the layout of the elements on each given page.`}</p>
      <p>{`The PDF Extract API provides a method for developers to extract and structure content for use in a number of downstream applications including content republishing, content processing, data analysis, and content aggregation, management, and search.`}</p>
      <p>{`The PDF Extract API can be embedded into any application using the `}<a parentName="p" {...{
          "href": "../pdf-extract-api/gettingstarted#sdk"
        }}>{`PDFServices SDK`}</a>{` for Node.js, Python, .NET and Java. `}<a parentName="p" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-extract-api"
        }}>{`Start with a Free Tier which includes 500 free Document Transactions per month.`}</a></p>
    </p>
    <h2 {...{
      "id": "extract-process"
    }}>{`Extract Process`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1099px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "25.625000000000004%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/18fb6fd7224a217aed770df84103f50c/5530d/extract_process_21.webp 320w", "/document-services/docs/static/18fb6fd7224a217aed770df84103f50c/0c8fb/extract_process_21.webp 640w", "/document-services/docs/static/18fb6fd7224a217aed770df84103f50c/624f1/extract_process_21.webp 1099w"],
            "sizes": "(max-width: 1099px) 100vw, 1099px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/18fb6fd7224a217aed770df84103f50c/dd4a7/extract_process_21.png 320w", "/document-services/docs/static/18fb6fd7224a217aed770df84103f50c/0f09e/extract_process_21.png 640w", "/document-services/docs/static/18fb6fd7224a217aed770df84103f50c/c1d6f/extract_process_21.png 1099w"],
            "sizes": "(max-width: 1099px) 100vw, 1099px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/18fb6fd7224a217aed770df84103f50c/c1d6f/extract_process_21.png",
            "alt": "PDF Extract Process : PDF containing title, image, header, paragraph, list and table and provide output as json, png and csv files to client applications",
            "title": "PDF Extract Process : PDF containing title, image, header, paragraph, list and table and provide output as json, png and csv files to client applications",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      